import React from 'react';
import './App.css';
import { LanguageProvider } from './context/LanguageContext';
import Header from './components/Header';

import SupabaseProvider from './providers/SupabaseProvider';
import HomePage from './pages/HomePage';
import { BrowserRouter, Route, Router, Routes } from 'react-router-dom';
import AdminDashboard from './pages/AdminDashboard';

function App() {
    return (
        <LanguageProvider>
            <SupabaseProvider>
                <BrowserRouter>
                    <Routes>
                        <Route path='/' element={<HomePage />} />
                        <Route
                            path='/admin-gallery'
                            element={<AdminDashboard />}
                        />
                    </Routes>
                </BrowserRouter>
            </SupabaseProvider>
        </LanguageProvider>
    );
}

export default App;
